import { attachmentSchema } from '@/config/request';
import { useQueryParameters } from '@/hooks/useQueryParameters';
import AttachmentsForm from '@oncolens/oncolens-ui/lib/components/Common/EventAttachments/AttachmentsForm';
import { EventAttachmentDto } from '@oncolens/oncolens-ui/lib/dto/attachments/Attachment';
import clsx from 'clsx';
import React, { useState } from 'react';

interface AttachmentsInformationProps {
	requestId: string;
}

export const AttachmentsInformation = ({ requestId }: AttachmentsInformationProps) => {
  const [attachments, setAttachments] = useState([] as EventAttachmentDto[]);
  const updateAttachments = (field: string, value: EventAttachmentDto[]) => setAttachments(value);
  const queryParameters = useQueryParameters();

  return (
    <div>
      <h3 className="mb-2 text-lg">Upload reports and images (optional)</h3>
      <div className={clsx('w-full', attachments.length > 2 ? 'overflow-y-auto h-96' : '')}>
        <AttachmentsForm
          readOnly={true}
          setValue={updateAttachments}
          schema={attachmentSchema}
          identifierValue={requestId}
          formAttachments={attachments}
          isInputRequest={false}
          emptyText="You don't have any images or reports."
          queryParameters={queryParameters}
          attachmentEventType="Collaboration Request"
        />
      </div>
    </div>
  );
};
